class SubnavScroll {
    constructor(el) {
        this.$el = el;
    }

    scrollRight(event) {
        event.data.this.subNavItems.animate(
            {
                scrollLeft: '+=' + event.data.this.visible_width,
            },
            300,
        );
    }

    scrollLeft(event) {
        event.data.this.subNavItems.animate(
            {
                scrollLeft: '-=' + event.data.this.visible_width,
            },
            300,
        );
    }

    scrollArrowsOpacity(event) {
        if (
            event.data.this.subNavItems.scrollLeft() +
                event.data.this.firstSubnavItem.offsetWidth ===
            event.data.this.firstSubnavItem.scrollWidth
        ) {
            event.data.this.$el.find('.nav-next').css('opacity', '.35');
        }
        if (
            event.data.this.subNavItems.scrollLeft() + event.data.this.firstSubnavItem.offsetWidth <
            event.data.this.firstSubnavItem.scrollWidth
        ) {
            event.data.this.$el.find('.nav-next').css('opacity', '1.0');
        }
        if (event.data.this.subNavItems.scrollLeft() === 0) {
            event.data.this.$el.find('.nav-prev').css('opacity', '.35');
        }
        if (event.data.this.subNavItems.scrollLeft() > 0) {
            event.data.this.$el.find('.nav-prev').css('opacity', '1.0');
        }
    }

    setupSubNav() {
        const self = this;
        if (self.$el?.length) {
            self.subNavItems = self.$el.find('.subnav__items');
            self.activeSubnav = self.$el.find('.subnav__items li a.active');

            if (!CBS.Registry.platform.isMobile) {
                self.checkArrowDisplay();

                let resizeTimer;
                $(window).on('resize', function () {
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(function () {
                        self.checkArrowDisplay();
                    }, 250);
                });

                self.firstSubnavItem = self.subNavItems[0];
                self.visible_width = self.firstSubnavItem.offsetWidth;

                self.subNavItems.scroll({ this: self }, self.scrollArrowsOpacity);

                self.$el.find('.nav-next').click({ this: self }, self.scrollRight);
                self.$el.find('.nav-prev').click({ this: self }, self.scrollLeft);
            }

            self.scrollActiveSubnavIntoView();
        }
    }

    scrollActiveSubnavIntoView() {
        let left = this.activeSubnav[0]?.offsetLeft;
        let offset = this.activeSubnav.offset();
        let compensatePageSize = $(window).width() / 2 - this.activeSubnav.width() / 2;

        if (left !== undefined) {
            this.subNavItems.scrollLeft(left - compensatePageSize);
        } else if (offset) {
            this.subNavItems.scrollLeft(offset.left - compensatePageSize);
        }
    }

    checkArrowDisplay() {
        // subnav edges
        let subnavRect = this.subNavItems[0]?.getBoundingClientRect();
        let subnavRightEdge = Math.round(subnavRect?.right ?? 0);
        let subnavLeftEdge = Math.round(subnavRect?.left ?? 0);

        // li list
        let liList = this.subNavItems.find('li:visible');

        // first li
        let firstItem = liList.first();
        let firstItemRect = firstItem[0]?.getBoundingClientRect();
        let firstItemLeftEdge = Math.round(firstItemRect?.left ?? 0);

        // last visible li
        let lastItem = liList.last();
        let lastItemRect = lastItem[0]?.getBoundingClientRect();
        let lastItemRightEdge = Math.round(lastItemRect?.right ?? 0);

        if (firstItemLeftEdge < subnavLeftEdge || lastItemRightEdge > subnavRightEdge) {
            this.$el.addClass('has-arrows');
        } else {
            this.$el.removeClass('has-arrows');
        }
    }
}

$(document).ready(function () {
    const subNavScroll = new SubnavScroll($('#subnav:visible'));
    subNavScroll.setupSubNav();
});

export default SubnavScroll;
